import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 28 28"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M20.767 11.667c1.306 0 1.96 0 2.459-.255.439-.223.796-.58 1.02-1.02.254-.498.254-1.152.254-2.459v-.7c0-1.306 0-1.96-.254-2.459a2.33 2.33 0 0 0-1.02-1.02c-.5-.254-1.152-.254-2.46-.254H7.234c-1.306 0-1.96 0-2.459.254-.439.224-.796.581-1.02 1.02-.254.5-.254 1.153-.254 2.46v.7c0 1.306 0 1.96.254 2.459.224.439.581.796 1.02 1.02.5.254 1.153.254 2.46.254zM20.767 24.5c1.306 0 1.96 0 2.459-.254.439-.224.796-.581 1.02-1.02.254-.5.254-1.152.254-2.46v-.7c0-1.306 0-1.96-.254-2.459a2.33 2.33 0 0 0-1.02-1.02c-.5-.254-1.152-.254-2.46-.254H7.234c-1.306 0-1.96 0-2.459.255-.439.223-.796.58-1.02 1.02-.254.498-.254 1.152-.254 2.459v.7c0 1.306 0 1.96.254 2.459.224.439.581.796 1.02 1.02.5.254 1.153.254 2.46.254z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }